module.exports = __webpack_public_path__ + "img/制御工学2_9.ca618a9e.png";